// extracted by mini-css-extract-plugin
export var cardTitle = "_hn-1";
export var commentBubble = "_hn-e";
export var commentForm = "_hn-a";
export var commentInput = "_hn-b";
export var commentLabel = "_hn-d";
export var commentPrompt = "_hn-9";
export var csatCard = "_hn-0";
export var feedbackSection = "_hn-7";
export var starDisabled = "_hn-6";
export var starEmpty = "_hn-5";
export var starFilled = "_hn-4";
export var starWrapper = "_hn-3";
export var starsContainer = "_hn-2";
export var submittedComment = "_hn-c";
export var thankYouText = "_hn-8";